import { useTranslation } from 'react-i18next'

import { TRANSLATION_NAMESPACE } from './setupTranslations'

export const useAccountSettingsTranslation = () =>
  useTranslation(TRANSLATION_NAMESPACE)
